module.exports = __webpack_public_path__ + "static/media/501OliverStNW_2018-07-09_201.3ef2f4aa.jpg";